/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemHealthResponseSchema } from './itemHealthResponseSchema';

export const itemHealthByItemIdsResponseSchema = z.object({
  get data() {
    return z.array(itemHealthResponseSchema).describe('Health data for requested items');
  },
});
